import { Descriptions } from 'antd';
import { t } from '@/utils/translator';
import { STYLE_CONSTANTS } from '@/constants/siteData';

function SiteCard({ site }) {
  return (
    <Descriptions
      column={5}
      size="small"
      layout="vertical"
      labelStyle={STYLE_CONSTANTS.descStyleHeader}
      contentStyle={STYLE_CONSTANTS.descStyleBody}
      bordered
    >
      <Descriptions.Item label={t('사업장명')}>{site.site_name}</Descriptions.Item>
      <Descriptions.Item label={t('소속 기업')}>{site.company_name}</Descriptions.Item>
      <Descriptions.Item label={t('사업장 주소')}>{site.site_location}</Descriptions.Item>
      <Descriptions.Item label={t('사업장 국가')}>{site.site_country}</Descriptions.Item>
      <Descriptions.Item label={t('HL 만도 거래법인')}>
        {site.site_clients?.join(', ')}
      </Descriptions.Item>
    </Descriptions>
  );
}

export default SiteCard;
